export default
{
    emits:
    [
        'update:modelValue',
        'drag:enter',
        'drag:leave',
        'on:click',
        'on:drop',
        'upload:start',
        'upload:end'
    ]
}